// extracted by mini-css-extract-plugin
module.exports = {"textDisable":"AssociatedWireless_textDisable__2sTGs","table":"AssociatedWireless_table__vWJH1"};